import { useMutation } from '@apollo/client'
import { useState } from 'react'
import { errorMapping } from 'utils/errorUtils'

import { Flex, FormControl, FormLabel, Input, Textarea } from '@chakra-ui/react'

import LynkAlert from 'components/LynkAlert'
import LynkModal from 'components/LynkModal'

import { CreateProjectGroup, UpdateProjectGroup } from 'graphQL/Mutation'

import { BiSolidLayerPlus } from 'react-icons/bi'

const ProductModal = ({ isOpen, onClose, data }) => {
  const { id, name, description } = data || ''
  const [projectGroupCreate, { loading: crLoading }] =
    useMutation(CreateProjectGroup)
  const [projectGroupUpdate, { loading: upLoading }] =
    useMutation(UpdateProjectGroup)

  const initialData = { name: name || '', desc: description || '' }
  const [formData, setFormData] = useState(initialData)
  const [error, setError] = useState('')

  const updateProduct = () => {
    projectGroupUpdate({
      variables: {
        id: id,
        name: formData?.name,
        desc: formData?.desc
      }
    }).then((res) => {
      const error = res?.data?.projectGroupUpdate?.errors
      if (error?.length > 0) {
        setError(res.data.projectGroupUpdate.errors[0])
      } else {
        onClose()
      }
    })
  }

  const handleSave = () => {
    projectGroupCreate({
      variables: {
        enabled: true,
        name: formData?.name,
        desc: formData?.desc
      }
    }).then((res) => {
      const error = res?.data?.projectGroupCreate?.errors
      if (error?.length > 0) {
        setError(error[0])
      } else {
        onClose()
      }
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
    setError('')
  }

  return (
    <LynkModal
      isOpen={isOpen}
      onClose={onClose}
      Icon={BiSolidLayerPlus}
      disabled={error !== ''}
      buttonText={data ? 'Update' : 'Save'}
      isLoading={data ? upLoading : crLoading}
      title={`${data ? 'Edit' : 'Add'} Product`}
      onSubmit={data ? updateProduct : handleSave}
    >
      <Flex width={'100%'} direction={'column'} gap={4}>
        {error !== '' && <LynkAlert msg={errorMapping[error] || error} />}
        <FormControl isRequired>
          <FormLabel fontSize={12}>Name</FormLabel>
          <Input
            name='name'
            type='text'
            value={formData?.name}
            onChange={handleChange}
            placeholder={`Add product name`}
          />
        </FormControl>
        <FormControl>
          <FormLabel fontSize={12}>Description</FormLabel>
          <Textarea
            rows={5}
            name='desc'
            value={formData?.desc}
            onChange={handleChange}
            placeholder={`Add product description`}
          />
        </FormControl>
      </Flex>
    </LynkModal>
  )
}

export default ProductModal
